import { message, Modal, Result } from "antd";
import axios from "axios";
import Cookies from "js-cookie";

const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export async function getPdf(
  endpoint,
  name,
  { onSuccess = () => null, onError = () => null }
) {
  const token = Cookies.get("rapid-money-token");
  const response = await fetch(
    [process.env.REACT_APP_API_URL, endpoint].join(""),
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    }
  );
  if (response.ok) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    onSuccess();
  } else {
    console.log("Request failed with status:", response.status);
    onError();
  }
}

export async function printPdf(
  endpoint,
  name,
  { onSuccess = () => null, onError = () => null }
) {
  const token = Cookies.get("rapid-money-token");
  const response = await fetch(
    [process.env.REACT_APP_API_URL, endpoint].join(""),
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    }
  );

  if (response.ok) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const newWindow = window.open(url);
    if (newWindow) {
      newWindow.addEventListener("load", () => {
        newWindow.print();
        newWindow.onafterprint = () => {
          newWindow.close();
          window.URL.revokeObjectURL(url);
        };
      });
    } else {
      console.error("Failed to open the new window.");
    }

    onSuccess();
  } else {
    console.log("Request failed with status:", response.status);
    onError();
  }
}

apiInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data.status === "Error") {
        // if(response.data.message !== "Record Not Found" || response.data.data !== null){
        if (response.data.data !== null) {
          message.error(response.data.message);
        }
        return Promise.reject(response.data.message);
      }
      // message.success(response.data.message);
      return response.data;
    } else if (response.status === 201) {
      message.success(response.data.message);
      return response.data;
    }
  },
  (error) => {
    console.log('error',error); 
     if (error?.status === 422) {
      return Promise.reject(error.response.data);
    } else if (error?.status === 501) {
      message.warning(error.response.data.message);
    } else if (error?.status === 403) {
      message.error(error?.response?.data?.message);
      Cookies.remove("rapid-money-token");
      
      // Show 403 modal instead of redirecting
      Modal.info({
        title: "Session Expired",
        content: (
          <Result
            status="403"
            title="403"
            subTitle="Your login session has expired or another user has logged in with your account. Please login again to continue."
            extra={error?.response?.data?.message || "The provided token is invalid or has expired. Please try again."}
          />
        ),
        onOk() {
          window.location.href = "/login";
        },
        okText: "Go to Login",
        width: 600,
        centered: true,
        okButtonProps: {
          style: {
            backgroundColor: "#000000",
            borderColor: "#000000",
            color: "#ffffff"
          }
        }
      });
    } else if (error?.response?.data?.message) {
      message.error(error?.response?.data?.message);
    } else {
      message.error(error.message);
    }
    // if (error?.status === 403) {
    //   Cookies.remove("rapid-money-token");
    //   setTimeout(() => {
    //     window.history.go(-1);
    //   }, 2000);
    // }
    return Promise.reject(error);
  }
);

function requests(external_token) {
  let token = external_token ?? Cookies.get("rapid-money-token");
  let get = (url, data, withAuth = true, config = {}) => {
    let { headers = {}, ...restConfig } = config;
    if (withAuth) {
      config = {
        headers: {
          ...headers,
          Authorization: "Bearer " + token,
        },
        ...restConfig,
      };
    }
    return apiInstance.get(url, { ...config, params: { ...data } });
  };

  const post = (url, data, withAuth = true) => {
    let config = {};
    if (withAuth) {
      config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
    }
    return apiInstance.post(url, data, config);
  };

  const put = (url, data, withAuth = true) => {
    let config = {};
    if (withAuth) {
      config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
    }
    return apiInstance.put(url, data, config);
  };

  const del = (url, data, withAuth = true) => {
    let config = {};
    if (withAuth) {
      config = {
        headers: {
          Authorization: "Bearer " + token,
        },
        data: data,
      };
    }
    return apiInstance.delete(url, config);
  };

  const api = { get, post, put, del };
  return api;
}
export default requests;
